<div class="search-result" [ngClass]="backgroundClass">
    <div class="result-header">
        <div class="result-type-badge carrier">
            <mat-icon>local_shipping</mat-icon>
            <span class="badge-label">Carrier</span>
        </div>
        <div class="action-buttons" (click)="$event.stopPropagation()">
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                (click)="$event.stopPropagation(); gridButton()"
                [routerLink]="'datamaintenance/carriers'"
                [queryParams]="{ ID: item().ID }"
                matTooltip="Carrier Grid">
                <mat-icon class="no-margin">local_shipping</mat-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                (click)="contactButton()"
                matTooltip="Carrier Contacts">
                <mat-icon class="no-margin">person_add</mat-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-block d-lg-none"
                aria-label="toggle carrier menu button"
                [matMenuTriggerFor]="carrierMenu">
                <mat-icon class="no-margin">menu</mat-icon>
            </button>
        </div>
        @if (item().Blocked) {
            <div class="status-badge status-danger">BLOCKED</div>
        } @else if (item().Restriction) {
            <div class="status-badge status-warning">Restrictions</div>
        }
    </div>

    <div class="result-primary">
        <div class="result-id" [highlight]="searchTerm()">{{ primaryId }}</div>
        @if (carrierStatus.text) {
            <div class="warning-message">
                <mat-icon>warning</mat-icon>
                {{ carrierStatus.text }}
            </div>
        }
    </div>

    <div class="result-details">
        @if (fullAddress) {
            <div class="detail-row">
                <div class="detail-item">
                    <mat-icon class="detail-icon text-muted">place</mat-icon>
                    <span class="detail-value" [highlight]="searchTerm()">{{ fullAddress }}</span>
                </div>
            </div>
        }

        <div class="detail-grid">
            @if (item().MCNumber) {
                <div class="detail-item">
                    <span>
                        <mat-icon class="detail-icon text-muted">verified_user</mat-icon>
                        <span class="detail-label text-muted">MC:</span>
                    </span>
                    <span class="detail-value" [highlight]="searchTerm()">{{ item().MCNumber }}</span>
                </div>
            }
            @if (item().DOTNumber) {
                <div class="detail-item">
                    <span class="detail-label text-muted">DOT:</span>
                    <span class="detail-value" [highlight]="searchTerm()">{{ item().DOTNumber }}</span>
                </div>
            }
        </div>
    </div>
</div>

<mat-menu #carrierMenu="matMenu" xPosition="before">
    <div class="d-flex flex-column">
        <button
            mat-menu-item
            class="d-flex align-items-center"
            (click)="gridButton()"
            [routerLink]="'datamaintenance/carriers'"
            [queryParams]="{ ID: item().ID }">
            <mat-icon color="primary">local_shipping</mat-icon>
            <span>Carrier Grid</span>
        </button>
        <button mat-menu-item class="d-flex align-items-center" (click)="contactButton()">
            <mat-icon color="primary">person_add</mat-icon>
            <span>Carrier Contacts</span>
        </button>
    </div>
</mat-menu>
